( () => {

    const markers = [];
    const sidebarLocations = [];
    const setupLocations = [];
    const maxDestinationsRequest = 25;
    const markerDefaultSrc = new URL(wordpress.themeURL + '/assets/src/img/pico_marker.png');
    const phoneImgSrc = new URL(wordpress.themeURL + '/assets/src/img/phone.png');
    const hoursImgSrc = new URL(wordpress.themeURL + '/assets/src/img/hours.png');
    const servicesImgSrc = new URL(wordpress.themeURL + '/assets/src/img/services.png');
    const startingPos = { lat: 29.423849258505793, lng: -95.24410586149571 };
    const mapDefaultZoom = 6;
    const mapSelectZoom = 7;
    let composedLocations = [];
    let processedLocations = [];
    let infoWindow = {};
    let searchOriginPosition;
    let searchMarker;
    let featureLayer;
    let map;

    window.addEventListener('DOMContentLoaded', function() {
        
        if ( ! document.getElementById("map") ) {
            return;   
        }

        const serviceFilterElement = document.getElementById("location-services-select");
        const productFilterElement = document.getElementById("location-products-select");
        const serviceFilterReset = document.getElementById("reset-services-filter");
        const productFilterReset = document.getElementById("reset-products-filter");

        initMap();
        
        serviceFilterElement.addEventListener('change', function(event) {
            executeFilter(serviceFilterElement, productFilterElement, composedLocations);
        });

        productFilterElement.addEventListener('change', function(event) {
            executeFilter(serviceFilterElement, productFilterElement, composedLocations);
        });

        //console.log(serviceFilterReset);
        serviceFilterReset.addEventListener('click', (e) => {
            serviceFilterElement.selectedIndex = 0;
            serviceFilterElement.dispatchEvent(new Event('change', {bubbles: true}));
        });

        productFilterReset.addEventListener('click', (e) => {
            productFilterElement.selectedIndex = 0;
            productFilterElement.dispatchEvent(new Event('change', {bubbles: true}));
        });
    });

    async function initMap() {

        //Request needed libraries
        const { Map, InfoWindow }  = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const mapElement = document.getElementById("map");
        const searchElement = document.getElementById("map-search");
        const searchForm = document.getElementById("map-search-form");

        const mapLocationData = window.locationData ?? [];
        const mapBoundaryData = window.boundaryData ?? [];

        //console.log(mapLocationData);

        map = new Map( mapElement, {
            zoom: mapDefaultZoom,
            center: startingPos,
            //mapId: "177a13f3bcffca59503b6ff8", //"DEMO_MAP_ID"
            mapId: "ef7812cd190dfebcdc7888ec", //Client ID
            zoomControl: true,
        });

        infoWindow = new google.maps.InfoWindow();
        featureLayer = map.getFeatureLayer("ADMINISTRATIVE_AREA_LEVEL_2");

        //console.log(featureLayer);

        if ( mapLocationData.length > 0 ) {

            mapLocationData.forEach( function(location) {
                //console.log(location);

                const sidebarLocation = setupSidebarLocation(location);
                sidebarLocations.push(sidebarLocation);

                const mapMarker = setupMarker(location, AdvancedMarkerElement, map);
                markers.push(mapMarker);

                setupLocationData(location, sidebarLocation, mapMarker);
            });

            renderMarkers(markers, map);
            renderSidebarLocations(sidebarLocations);

            composedLocations = setupLocations;
        }

        searchForm.addEventListener('submit', function(event) {
            event.preventDefault();
            const searchValue = searchElement.value;

            searchQuery(searchValue, map);
        });

        //Submit search on load if value exists
        if ( searchElement.value ) {
            searchForm.requestSubmit();
        }

        //Add boundaries
        if ( mapBoundaryData.length !== 0 ) {
            styleBrandBoundaries(mapBoundaryData);
        }

        featureLayer.addListener('click', (event) => {
            clickCreateFeatureInfo(event, mapBoundaryData);
        });
    }

    async function clickCreateFeatureInfo(event, boundaryData) {
        //console.log(event);

        const boundary = event.features[0];
        const boundaryLatLng = event.latLng;
        const boundaryInfo = await boundary.fetchPlace();
        const boundaryDisplayName = boundaryInfo.displayName;
        const boundaryId = boundaryInfo.id;

        //console.log(boundaryInfo);

        const boundaryItem = boundaryData.find( function(place) {
            return place.id == boundaryId;
        });

        let boundaryBrand = '';

        if ( boundaryItem ) {
            boundaryBrand = boundaryItem.brand;
            updateInfoWindow(boundaryDisplayName, '', boundaryLatLng);
        }
    }

    async function searchQuery(query, map) {
        const { Place } = await google.maps.importLibrary("places");
        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
        const mapMessageElement = document.getElementById('map-message');

        //Clear message if active
        mapMessageElement.classList.remove('active');

        const filterQuery = query.toString();

        //const testFields = ['*'];
        const fields = ["id", "location", "displayName", "formattedAddress"];

        const request = {
            textQuery: filterQuery,
            fields: fields,
            region: 'us',
        };

        const { places } = await Place.searchByText(request);

        if ( places.length ) {
            //console.log(places);
            
            const { LatLngBounds } = (await google.maps.importLibrary('core'));
            const bounds = new LatLngBounds();

            //Remove existing search marker
            if ( searchMarker ) {
                searchMarker.map = null;
            }

            //Only handle one search result
            const place = places[0];

            const queryMarker = new AdvancedMarkerElement({
                map: map,
                position: place.location,
                title: place.displayName,
            });

            //console.log(queryMarker.position);

            //Set marker class
            queryMarker.classList.add('visible');
            queryMarker.classList.add('search-marker');

            map.panTo(place.location);
            map.setZoom(mapDefaultZoom);

            queryMarker.addEventListener('gmp-click', () => {
                updateInfoWindow(place.displayName, place.formattedAddress, queryMarker);
            });

            //queryMarker.click();

            searchMarker = queryMarker;
            searchOriginPosition = {lat: queryMarker.position.lat, lng: queryMarker.position.lng};
        }

        await processNearestLocations(setupLocations, searchOriginPosition);
    }

    async function processNearestLocations(locations, origin) {
        const sidebarParent = document.querySelector('.locations-map-side-panel');
        const sidebarSpinner = sidebarParent.querySelector('.spinner');
        const sidebarInner = sidebarParent.querySelector('.sidebar-wrapper');

        sidebarInner.style.filter = "blur(10px)";
        sidebarSpinner.classList.add('active');

        locations.forEach( function(location) {
            const distanceMilesSource = getLocalDistance( origin.lat, origin.lng, location.position.lat, location.position.lng );
            const distanceMiles = Math.floor(distanceMilesSource);

            location.distanceText = `${distanceMiles} mi`;
            location.distanceValue = distanceMiles;

            processedLocations.push(location);
        });

        window.setTimeout( () => {
            updateNearestLocations();
            sidebarInner.style.filter = "none";
            sidebarSpinner.classList.remove('active');
        }, 1000 );
    }

    function getLocalDistance( lat1, lon1, lat2, lon2 ) {
        let rad = function(x) {
            return ( x * Math.PI / 180 );
        }

        let dLat    = rad( lat2 - lat1 );
        let dLon    = rad( lon2 - lon1 );
        let a       = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
                        Math.cos( rad( lat1 ) ) * Math.cos( rad( lat2 ) ) *
                        Math.sin( dLon / 2) * Math.sin( dLon / 2 );
        let c       = ( 2 * Math.atan2( Math.sqrt(a), Math.sqrt( 1 - a ) ) );
        let miles   = ( ( 6378137 * c ) / 1600 );

        return miles;
    }

    // async function processNearestLocations(locations, origin) {
    //     const distanceService = new google.maps.DistanceMatrixService();
    //     const locationBatch = [];

    //     locations.forEach( function(location) {
    //         const parseCoordinates = {
    //             lat: location.latitude,
    //             lng: location.longitude
    //         }

    //         locationBatch.push(parseCoordinates);
    //     });

    //     //console.log(locationBatch);

    //     //Visual loader for sidebar
    //     const sidebarParent = document.querySelector('.locations-map-side-panel');
    //     const sidebarSpinner = sidebarParent.querySelector('.spinner');
    //     const sidebarInner = sidebarParent.querySelector('.sidebar-wrapper');

    //     sidebarInner.style.filter = "blur(10px)";
    //     sidebarSpinner.classList.add('active');

    //     //Exit if batches are empty
    //     if ( locationBatch.length == 0 ) {
    //         updateNearestLocations();
    //         sidebarInner.style.filter = "none";
    //         sidebarSpinner.classList.remove('active');

    //         return;
    //     }

    //     // console.log('CURRENT BATCH');
    //     // console.log(locationBatch);
        
    //     const batch = locationBatch.slice(0, maxDestinationsRequest);

    //     const distancesList = await getDistances(distanceService, locations, {
    //         origins: [origin],
    //         destinations: batch,
    //         travelMode: 'DRIVING',
    //         unitSystem: google.maps.UnitSystem.IMPERIAL,
    //     }).catch((e) => {
    //         console.log(`Distance sort error: ${e}`);
    //     });

    //     // console.log('PROCESSED BATCH');
    //     // console.log(distancesList);

    //     processedLocations.push(distancesList);

    //     await processNearestLocations(locations.slice(maxDestinationsRequest), searchOriginPosition);
    // }

    // async function getDistances(distanceService, locations, parameters) {

    //     return new Promise((resolve, reject) => {
            
    //         distanceService.getDistanceMatrix(parameters, (response, status) => {
    //             if ( status != google.maps.DistanceMatrixStatus.OK ) {
    //                 reject(response);
    //             } else {
    //                 const distances = [];
    //                 const results = response.rows[0].elements;

    //                 //console.log(response);

    //                 const noResults = results.every( function(status) {
    //                     return status.status === "ZERO_RESULTS";
    //                 });

    //                 if ( noResults ) {
    //                     const mapMessageElement = document.getElementById('map-message');

    //                     mapMessageElement.classList.add('active');
    //                     mapMessageElement.innerHTML = `
    //                     <p>Nearest locations can't be found. Please search again.</p>
    //                     `;

    //                     //resolve(distances);
    //                 }

    //                 if ( results.length !== 0 && ! noResults ) {

    //                     for ( let i = 0; i < results.length; i++ ) {
    //                         const element = results[i];
    //                         const distanceText = element.distance.text;
    //                         const distanceValue = element.distance.value;

    //                         const distanceObject = {
    //                             distanceText: distanceText,
    //                             distanceValue: distanceValue,
    //                             ...locations[i],
    //                         };

    //                         distances.push(distanceObject);
    //                     }

    //                     resolve(distances);
    //                 }
    //             }
    //         }).then((response) => {
    //             //console.log(response);
    //         }).catch((e) => {
    //             console.log(e);
    //         });
    //     });
    // }

    async function updateInfoWindow(title, content, anchor) {

        if ( anchor.nodeName === undefined ) {
            infoWindow.setPosition(anchor);
        }

        infoWindow.setContent(content);
        infoWindow.setHeaderContent(title);
        infoWindow.open({
            map,
            anchor,
            shouldFocus: false,
        });
    }

    function updateNearestLocations() {
        // console.log('FINISHED!');
        // console.log(processedLocations);

        const locationsSort = [];
        const sidebarLocations = [];

        if ( processedLocations !== undefined && processedLocations.length > 0 ) {

            //OLD
            // processedLocations.forEach( function(locationBatch) {

            //     if ( locationBatch.length > 0 ) {

            //         locationBatch.forEach( function(locationObject) {
            //             locationsSort.push(locationObject);
            //         });
            //     }
            // });
            processedLocations.forEach( function(location) {
                locationsSort.push(location);
            });

            // console.log('SORTED START');
            // console.log(locationsSort);

            composedLocations = locationsSort.toSorted((first, second) => {
                return first.distanceValue - second.distanceValue;
            });

            // console.log('SORTED FINAL');
            // console.log(composedLocations);
        }

        composedLocations.forEach( function(location) {

            if ( location.distanceText ) {
                const contentWrapper = location.sidebarLocation.querySelector('.content-wrapper');
                const contentDistance = location.sidebarLocation.querySelector('.distance');

                if ( contentDistance === null ) {
                    contentWrapper.innerHTML += `<div class="distance"><p>${location.distanceText}</p></div>`;
                } else {
                    contentDistance.innerHTML = `<p>${location.distanceText}</p>`;
                }
            }

            sidebarLocations.push(location.sidebarLocation);        
        });

        renderSidebarLocations(sidebarLocations);

        //Scroll back to first item

        if ( sidebarLocations.length !== 0 ) {
            sidebarLocations[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                container: 'nearest'
            });
        }
        
        //Reset
        processedLocations = [];
        searchOriginPosition = null;
    }

    function setLocationVisibility(filters, locations) {

        if ( locations.length !== 0 ) {

            locations.forEach( function(location) {
                const locationFilters = location.locationFilters;
                const locationSidebar = location.sidebarLocation;
                const locationMarker = location.marker;

                if ( filters ) {

                    const searchFilters = filters.split(' ');
                    const filterMatch = searchFilters.every( (filterTerm) => {
                        return locationFilters.includes(filterTerm);
                    });

                    if ( filterMatch ) {
                        locationSidebar.classList.add('visible');
                        locationMarker.classList.add('visible');
                    } else {
                        locationSidebar.classList.remove('visible');
                        locationMarker.classList.remove('visible');
                    }

                } else {
                    locationSidebar.classList.add('visible');
                    locationMarker.classList.add('visible');
                }

            });
        }
    }

    function setupSidebarLocation(location = {}) {
        const title = location.title;
        const phone = location.phone;
        const city = location.city;
        const state = location.stateAbbr;
        const zip = location.zip;
        const altPin = location.altPin;
        const directionsUrl = location.directionsUrl;
        const siteUrl = location.siteUrl;
        const fullAddress = location.fullAddress1;
        const hours = location.hours;
        const products = location.productGroups;
        const services = location.serviceGroups;
        const distance = location.distanceText;
        const maintenanceMode = location.inMaintenanceMode;
        const sidebarLocation = document.createElement('li');
        const locationServicesHTML = document.createElement('div');
        const locationProductsHTML = document.createElement('div');
        let locationIconSrc;

        locationServicesHTML.classList.add('inner-row', 'services-row');
        locationProductsHTML.classList.add('inner-row', 'products-row');

        locationServicesHTML.innerHTML += `
        <figure class="icon-wrapper">
            <img src="${servicesImgSrc}" />
        </figure>
        <div class="content-wrapper">
            <div class="title-wrapper">
                <h5 class="title">Services</h5>
            </div>
            <div class="services-list-wrapper"></div>
        </div>
        `;

        locationProductsHTML.innerHTML += `
        <figure class="icon-wrapper">
            <img src="${servicesImgSrc}" />
        </figure>
        <div class="content-wrapper">
            <div class="title-wrapper">
                <h5 class="title">Products</h5>
            </div>
            <div class="products-list-wrapper"></div>
        </div>
        `;

        const locationServicesList = locationServicesHTML.querySelector('.services-list-wrapper');
        const locationProductsList = locationProductsHTML.querySelector('.products-list-wrapper');

        if ( services.length > 0 ) {

            services.forEach( function(serviceGroup) {
                const serviceTitleElement = document.createElement('span');
                const serviceWrapperElement = document.createElement('ul');
                
                serviceTitleElement.classList.add('service-title');
                serviceWrapperElement.classList.add('services-list');

                serviceTitleElement.innerHTML = serviceGroup.name;

                if ( serviceGroup.children.length > 0 ) {

                    serviceGroup.children.forEach( function(service) {
                        const serviceItemElement = document.createElement('li');

                        serviceItemElement.classList.add('service-item');

                        serviceItemElement.innerHTML = service.name;
                        serviceWrapperElement.append(serviceItemElement);
                    });
                    
                    locationServicesList.append(serviceTitleElement);
                    locationServicesList.append(serviceWrapperElement);
                }
            });
        }

        if ( products.length > 0 ) {

            products.forEach( function(productGroup) {
                const productWrapperElement = document.createElement('ul');
                
                productWrapperElement.classList.add('products-list');

                if ( productGroup.children.length > 0 ) {

                    productGroup.children.forEach( function(product) {
                        const productItemElement = document.createElement('li');

                        productItemElement.classList.add('product-item');

                        productItemElement.innerHTML = product.name;
                        productWrapperElement.append(productItemElement);
                    });
                    
                    locationProductsList.append(productWrapperElement);
                }
            });
        }

        if ( location.altPin.url ) {
            locationIconSrc = location.altPin.url;
        } else {
            locationIconSrc = markerDefaultSrc.href;
        }

        sidebarLocation.classList.add('sidebar-item', 'visible');
        sidebarLocation.dataset.locationId = location.id;

        const phoneHTML = `
        <div class="inner-row">
            <figure class="icon-wrapper">
                <img src="${phoneImgSrc}" />
            </figure>
            <div class="content-wrapper">
                <div class="title-wrapper">
                    <h5 class="title">Phone</h5>
                </div>
                <div class="phone-number-wrapper">
                    <span class="phone-number">${phone}</span>
                </div>
            </div>
        </div>
        `;

        const hoursHTML = `
        <div class="inner-row">
            <figure class="icon-wrapper">
                <img src="${hoursImgSrc}" />
            </figure>
            <div class="content-wrapper">
                <div class="title-wrapper">
                    <h5 class="title">Hours</h5>
                </div>
                <div class="hours-wrapper">
                    <div class="hours">${hours}</div>
                </div>
            </div>
        </div>
        `;

        sidebarLocation.innerHTML = `
        <div class="item-content-wrapper">
            <details class="location-details" name="locations">
                <summary>
                    <div class="content-row">
                        <figure class="icon-wrapper">
                            <img src="${locationIconSrc}" />
                        </figure>
                        <div class="content-wrapper">
                            <div class="title-wrapper">
                                <h4 class="title">${title}</h4>
                            </div>
                                
                            <div class="city-state-wrapper">
                                <p>${city}, ${state}</p>
                            </div>

                            <div class="directions-wrapper">
                                <a href="${directionsUrl}" target="_blank">
                                    <address>${fullAddress}</address>
                                </a>

                                ${! maintenanceMode ? 
                                    `<a href="${siteUrl}/" target="_blank"><div class="link-wrapper"><span>Visit Location Site</span></div></a>` 
                                    :
                                    ''
                                }
                            </div>
                        </div>
                    </div>
                </summary>

                ${phone ? phoneHTML : '' }
                ${hours ? hoursHTML : '' }
                ${services.length > 0 ? locationServicesHTML.outerHTML : '' }
                ${products.length > 0 ? locationProductsHTML.outerHTML : '' }
            </details>
        </div>
        `;

        return sidebarLocation;
    }

    function setupMarker(location = {}, AdvancedMarkerElement = {}) {

        //Parse lat & lng
        const lat = parseFloat( location.latitude );
        const lng = parseFloat( location.longitude );
        const markerPos = { lat: lat, lng: lng };

        //Create AdvancedMarkerElement instance
        const marker = new AdvancedMarkerElement({
            position: markerPos,
            title: `${location.title} ${location.subTitle}`,
            gmpClickable: true,
        });

        //Setup & append icon
        const markerIconImg = document.createElement('img');
        markerIconImg.classList.add('marker-icon');

        if ( location.altPin.url ) {
            markerIconImg.src = location.altPin.url;
        } else {
            markerIconImg.src = markerDefaultSrc.href;
        }
        
        marker.append(markerIconImg);

        //Set marker class
        marker.classList.add('visible');

        //Set marker data attributes
        marker.dataset.locationId = location.id;
        marker.dataset.latitude = lat;
        marker.dataset.longitude = lng;

        //Set click event
        marker.addEventListener('gmp-click', () => {
            //console.log(`clicked: ${location.title} ${location.city}`);

            const currentLocationId = location.id;
            const currentLocation = document.querySelector(`.sidebar-item[data-location-id="${currentLocationId}"]`);
            const currentDetailsElement = currentLocation.querySelector('.location-details');
            const sidebarItems = document.querySelectorAll('.sidebar-item');

            sidebarItems.forEach( (location) => {
                const details = location.querySelector('.location-details');

                location.classList.remove('highlight');

                details.removeAttribute('open');
            });

            currentLocation.classList.add('highlight');

            currentDetailsElement.setAttribute('open', true);

            currentLocation.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                container: 'nearest'
            });
        });

        return marker;
    }

    function renderMarkers(markers, map) {

        markers.forEach( (marker) => {
            marker.map = map;
        });
    }

    function renderSidebarLocations(sidebarLocations) {
        const sidePanel = document.querySelector('.side-panel-inner');
        const sidebarWrapper = document.createElement('ul');
        
        sidebarWrapper.classList.add('sidebar-wrapper');

        sidebarLocations.forEach( (location) => {
            const locationDetails = location.querySelector('.location-details');
            
            location.classList.remove('highlight');
            locationDetails.removeAttribute('open');

            sidebarWrapper.append(location);

            location.addEventListener('click', function(event) {
                const currentLocationId = location.getAttribute('data-location-id');
                const currentMarker = document.querySelector(`gmp-advanced-marker[data-location-id="${currentLocationId}"]`);
                const currentMarkerIcon = currentMarker.querySelector('.marker-icon');
                const allMarkers = document.querySelectorAll('gmp-advanced-marker:not(.search-marker)');
                const allLocations = sidebarLocations;
                const currentMarkerLatLng = {
                    lat: parseFloat(currentMarker.getAttribute('data-latitude')),
                    lng: parseFloat(currentMarker.getAttribute('data-longitude'))
                };

                allLocations.forEach( function(locationItem) {
                    locationItem.classList.remove('highlight');
                });

                allMarkers.forEach( function(marker) {
                    const markerIcon = marker.querySelector('.marker-icon');

                    markerIcon.classList.remove('bounce');
                    markerIcon.offsetHeight; //force browser repaint so animation can occur again w/ class change
                });

                currentMarkerIcon.classList.add('bounce');
                location.classList.add('highlight');

                map.panTo(currentMarkerLatLng);
                //map.setZoom(mapSelectZoom);
            });
        });

        sidePanel.innerHTML = "";
        sidePanel.append(sidebarWrapper);

        //console.log(sidePanel);
    }

    function setupLocationData(location, sidebar, marker) {

        if ( location.productGroups.length !== 0 || location.productGroups.length !== 0 ) {

            const locationData = {
                locationId: location.siteId,
                title: location.title,
                subTitle: location.subTitle,
                position: {
                    lat: parseFloat( location.latitude ),
                    lng: parseFloat( location.longitude ),
                },
                latitude: parseFloat( location.latitude ),
                longitude: parseFloat( location.longitude ),
                locationFilters: '',
                sidebarLocation: null,
                marker: null,
            };

            if ( sidebar ) {
                locationData.sidebarLocation = sidebar;
            }

            if ( marker ) {
                locationData.marker = marker;
            }

            if ( location.productGroups.length !== 0 ) {

                location.productGroups.forEach( function(productParent) {

                    if ( productParent.children.length !== 0 ) {

                        productParent.children.forEach( function(product) {
                            locationData.locationFilters += `product-${product.id} `;
                        });
                    }
                });
            }

            if ( location.serviceGroups.length !== 0 ) {

                location.serviceGroups.forEach( function(serviceParent) {

                    if ( serviceParent.children.length !== 0 ) {

                        serviceParent.children.forEach( function(service) {
                            locationData.locationFilters += `service-${service.id} `;
                        });
                    }
                });
            }

            //Trim end of filter string
            locationData.locationFilters = locationData.locationFilters.trimEnd();

            setupLocations.push(locationData);
        }
    }

    function executeFilter(serviceFilterElement, productFilterElement, locations) {
        let locationFilters = '';

        if ( ! serviceFilterElement.value ) {
            //console.log('No service filter!');
        }

        if ( ! productFilterElement.value ) {
            //console.log('No product filter!');
        }

        if ( serviceFilterElement.value && productFilterElement.value ) {
            //console.log('Both service and product filters!');
        }

        if ( serviceFilterElement.value ) {
            locationFilters += `${serviceFilterElement.value} `;
        }

        if ( productFilterElement.value ) {
            locationFilters += `${productFilterElement.value} `;
        }

        locationFilters = locationFilters.trimEnd();

        setLocationVisibility(locationFilters, locations);
    }

    function styleBrandBoundaries(placeData) {
        const mapContainerElement = document.querySelector('.locations-map-google-map');
        const mapBoundaryLegend = document.createElement('div');

        mapBoundaryLegend.id = 'map-boundary-legend';

        mapContainerElement.append(mapBoundaryLegend);

        const styleFillPico = {
            strokeColor: "#00843D",
            strokeOpacity: 0.5,
            strokeWeight: 2.0,
            fillColor: "#00843D",
            fillOpacity: 0.35,
        };

        const styleFillMcAdams = {
            strokeColor: "#0c2b96",
            strokeOpacity: 0.5,
            strokeWeight: 2.0,
            fillColor: "#0c2b96",
            fillOpacity: 0.35,
        };

        const styleFillJacobsGas = {
            strokeColor: "#800000",
            strokeOpacity: 0.5,
            strokeWeight: 2.0,
            fillColor: "#800000",
            fillOpacity: 0.35,
        };

        const styleFillClevelandPetroleum = {
            strokeColor: "#ffcd00",
            strokeOpacity: 0.5,
            strokeWeight: 2.0,
            fillColor: "#ffcd00",
            fillOpacity: 0.35,
        };

        let picoCount = 0;
        let mcAdamsCount = 0;
        let jacobsGasCount = 0;
        let clevelandPetroleumCount = 0;

        const picoLegendElement = document.createElement('div');
        const mcAdamsLegendElement = document.createElement('div');
        const jacobsGasLegendElement = document.createElement('div');
        const clevelandPetroleumLegendElement = document.createElement('div');

        picoLegendElement.id = 'pico-legend-item';
        picoLegendElement.classList.add('map-legend-item');

        mcAdamsLegendElement.id = 'mcadams-legend-item';
        mcAdamsLegendElement.classList.add('map-legend-item');

        jacobsGasLegendElement.id = 'jacobsgas-legend-item';
        jacobsGasLegendElement.classList.add('map-legend-item');

        clevelandPetroleumLegendElement.id = 'clevelandpetroleum-legend-item';
        clevelandPetroleumLegendElement.classList.add('map-legend-item');
        
        picoLegendElement.innerHTML = `
        <div class="color-swatch" style="background-color: ${styleFillPico.fillColor}">
        </div>
        <div class="title-wrapper">
            <span class="title">Pico</span>
        </div>
        `;
        
        mcAdamsLegendElement.innerHTML = `
        <div class="color-swatch" style="background-color: ${styleFillMcAdams.fillColor}">
        </div>
        <div class="title-wrapper">
            <span class="title">McAdams</span>
        </div>
        `;
        
        jacobsGasLegendElement.innerHTML = `
        <div class="color-swatch" style="background-color: ${styleFillJacobsGas.fillColor}">
        </div>
        <div class="title-wrapper">
            <span class="title">Jacobs Gas</span>
        </div>
        `;
        
        clevelandPetroleumLegendElement.innerHTML = `
        <div class="color-swatch" style="background-color: ${styleFillClevelandPetroleum.fillColor}">
        </div>
        <div class="title-wrapper">
            <span class="title">Cleveland Petroleum</span>
        </div>
        `;

        mapBoundaryLegend.append(picoLegendElement);
        mapBoundaryLegend.append(mcAdamsLegendElement);
        mapBoundaryLegend.append(jacobsGasLegendElement);
        mapBoundaryLegend.append(clevelandPetroleumLegendElement);

        featureLayer.style = (params) => {
            let target;
            let boundaryBrand;

            target = placeData.find( (place) => {
                if ( place.id === params.feature.placeId && place.brand === 'Pico' ) {
                    boundaryBrand = 'Pico';
                    picoCount++;

                    return true;
                }

                if ( place.id === params.feature.placeId && place.brand === 'McAdams' ) {
                    boundaryBrand = 'McAdams';
                    mcAdamsCount++;

                    return true;
                }

                if ( place.id === params.feature.placeId && place.brand === 'Jacobs Gas' ) {
                    boundaryBrand = 'Jacobs Gas';
                    jacobsGasCount++;

                    return true;
                }

                if ( place.id === params.feature.placeId && place.brand === 'Cleveland Petroleum' ) {
                    boundaryBrand = 'Cleveland Petroleum';
                    clevelandPetroleumCount++;

                    return true;
                }

                return false;
            });

            if ( target && boundaryBrand === 'Pico' ) {
                return styleFillPico;
            }

            if ( target && boundaryBrand === 'McAdams' ) {
                return styleFillMcAdams;
            }

            if ( target && boundaryBrand === 'Jacobs Gas' ) {
                return styleFillJacobsGas;
            }

            if ( target && boundaryBrand === 'Cleveland Petroleum' ) {
                return styleFillClevelandPetroleum;
            }
        };
    }

})();